import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Mail, Mailbox } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const EmailListenerTriggerNode = ({ data, selected }: NodeProps) => {
    return (
        <BaseNodeUI
            title={data?.label || "Event Listener (Email)"}
            icon={Mailbox}
            colorClass=""
            bgClass="bg-gradient-to-br from-blue-400 to-blue-600"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'}
            executionStatus={data?.executionStatus}
            isSource={true}
        >
            Attachment
        </BaseNodeUI>
    );
};

export default memo(EmailListenerTriggerNode);
